<template>
  <section class="privacy-page" :style="{ backgroundImage: `url('${backgroundImage}')` }">
    <div class="privacy-page__overlay">
      <div class="privacy-page__container">
        <div class="privacy-page__card">
          <h1 class="privacy-page__title">{{ tr.agreementTitle }}</h1>

          <div class="privacy-page__content">
            <span
              v-for="(item, index) in tr.agreement"
              :key="`agreement-${index}`"
              class="privacy-page__paragraph"
            >
              {{ item }}
            </span>
          </div>

          <div class="privacy-page__actions">
            <button type="button" class="privacy-page__button" @click="goBack">
              {{ backLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import logo from '@/assets/login/logo.svg';
import backgroundImage from '@/assets/login/background-login-page.png';
import { useLangStore } from '@/stores/lang';

const router = useRouter();
const { t } = useI18n();
const langStore = useLangStore();

const tr = computed(() => langStore.translations || {});
const backLabel = computed(() => t('back_button_label') || t('common.back') || 'Назад');

function goBack() {
  if (window.history.length > 1) {
    router.back();
    return;
  }
  router.push('/login');
}
</script>

<style scoped>
.privacy-page {
  min-height: 100vh;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.privacy-page__overlay {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
}

.privacy-page__container {
  width: 100%;
  max-width: 920px;
}

.privacy-page__logo {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.privacy-page__logo img {
  width: 150px;
  max-width: 260px;
}

.privacy-page__card {
  background: rgba(20, 34, 47, 0.72);
  border-radius: 10px;
  padding: 20px 18px;
  color: #fff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  max-width: 1020px;
  margin: 0 auto;
}

.privacy-page__title {
  margin: 0 0 16px;
  font-family: Roboto, sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
}

.privacy-page__content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: min(62vh, 680px);
  overflow-y: auto;
  padding-right: 4px;
  text-align: justify;
}

.privacy-page__paragraph {
  font-family: Roboto, sans-serif;
  font-size: 13px;
  line-height: 1.45;
  color: #fff;
}

.privacy-page__actions {
  margin-top: 20px;
}

.privacy-page__button {
  width: 100%;
  min-height: 52px;
  border: 1px solid #00c2ff;
  border-radius: 6px;
  background: #00c2ff;
  color: #fff;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.privacy-page__button:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 2px;
}

@media screen and (min-width: 768px) {
  .privacy-page__overlay {
    padding: 40px 24px;
  }

  .privacy-page__card {
    padding: 24px;
  }

  .privacy-page__title {
    font-size: 26px;
    line-height: 30px;
  }
}
</style>
